import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-688dd3e3")

_pushScopeId("data-v-688dd3e3")
const _hoisted_1 = {
  key: 0,
  class: "challenge-card h-auto py-5 flex justify-between flex-col rounded-3xl"
}
const _hoisted_2 = { class: " text-white flex flex-col text-center items-center justify-between w-full h-72 lg:h-96" }
const _hoisted_3 = {
  "data-testid": "title",
  class: "lobster text-6xl w-full font-bold"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", {
  "data-testid": "description-title",
  class: "montserrat font-normal w-full text-lg"
}, " Colossenses 3:16 ", -1)
const _hoisted_5 = { class: "flex w-full justify-evenly mt-16 font-bold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Jogar Novamente ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Início ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_logo = _resolveComponent("logo")
  const _component_trophy = _resolveComponent("trophy")
  const _component_blue_button = _resolveComponent("blue-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.challenge)
      ? (_openBlock(), _createBlock("section", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_logo, { class: "logo flat block px-0" }),
            _createVNode("div", null, [
              _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.heading), 1),
              _hoisted_4
            ]),
            _createVNode(_component_trophy, { class: "relative -bottom-5 h-32 lg:h-40" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: "montserrat w-full text-2xl mt-10",
      innerHTML: _ctx.message
    }, null, 8, ["innerHTML"]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_blue_button, {
        class: "bg-blue-600 bg-opacity-80 pt-1.5 pb-2 flex-grow sm:flex-grow-0 mx-2 sm:px-10",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go(-1)))
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_blue_button, {
        class: " bg-blue-600 bg-opacity-80 pt-1.5 pb-2 px-10 flex-grow sm:flex-grow-0 mx-2 sm:px-10",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.push('/')))
      }, {
        default: _withId(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ], 64))
})